export default __webpack_public_path__ + "static/media/regulatory--dual-path-bicycles-and-pedestrians--g1.02ec2d5e.png";